module.exports = __webpack_public_path__ + "img/banner3_1_th.c33ba858.png";